<template>
  <section class="container">
    <div class="col-md-8 mx-auto">
      <h2>User Conditions for Employers</h2>
      <p><strong>Last revision: 2024-12-12</strong></p>
      <p>
        This is an agreement between Comstream AB, Swedish registration number 556945-8911,
        hereinafter referred to as ”Comstream” and the Customer regarding the use of the online
        recruiting service platform, hereinafter “Jobshark”.
      </p>
      <p>To be able to use Jobshark, you must carefully read and accept the conditions below.</p>

      <h2>1. General conditions</h2>
      <p>
        By using the Service, the Customer gains access to job-seeking candidates, hereinafter
        "Candidates", with CVs and associated contact details for a certain job position,
        hereinafter "Position", registered via Jobshark.
      </p>
      <p>
        It is the Customer's responsibility to provide an adequate description of the Position and
        other relevant information for the Position. Jobshark may only be used for Positions that
        refer to employment or contract directly with the Customer. Comstream has the right to
        refuse a Position at its sole discretion.
      </p>
      <p>
        The Customer hereby consents to Comstream presenting the Position and basic information
        about the Customer to possible Candidates, as well as the Position and basic information
        about the Customer being advertised via Jobshark. Jobshark also has the right, at its sole
        discretion, to advertise the Position and basic information about the Customer through other
        channels such as social media and other job sites.
      </p>
      <p>
        If Comstream produces the job advertisement for a Position, the Customer may not use this in
        other contexts than for advertising via Jobshark.
      </p>
      <p>
        The Customer may not redistribute received Candidates to third parties without Comstream's
        approval.
      </p>

      <h2>2. Policy for Advertising</h2>
      <p>The following advertising guidelines apply. A job advertisement may not be used to:</p>
      <p>(a) advertise more than one job or more than one location</p>
      <p>
        (b) publish or offer jobs that do not comply with current legislation in any respect
        including labor laws, equality, discrimination, illegal stay, etc.
      </p>
      <p>(c) market or sell products or services</p>
      <p>
        (d) advertise or offer a business opportunity that does not involve employment or contract
        under presented conditions
      </p>
      <p>
        (e) advocate any particular political party, political program, political position or any
        political agenda
      </p>
      <p>(f) advocate any particular religion</p>
      <p>
        (g) require Candidates to provide information about age, race or ethnic origin, political
        beliefs, religious beliefs, sexual orientation or other information of a strictly private
        nature
      </p>
      <p>
        In the case of fraud or other misuse of Jobshark, Comstream reserves the right to deny you
        access to the service.
      </p>

      <h2>3. Subscribing to newsletter</h2>
      <p>
        By accepting this agreement, the Customer accepts to receive a regular newsletter by email
        from Jobshark. The Customer can decide to opt-out from the newsletter at any time.
      </p>

      <h2>4. Fees and Payment Conditions</h2>
      <p>
        Certain services offered by Comstream are associated with a cost. The Customer may order and
        accept the conditions for such services via Jobshark.
      </p>

      <h2>5. Agreement Term</h2>
      <p>
        The service is provided during the stated advertising period, after which the Customer has
        access to the information in Jobshark for at least one (1) more year.
      </p>

      <h2>6. Intellectual Property</h2>
      <p>
        The Customer may not use or forward job ads, advertising materials or descriptions of the
        competence profile that Comstream produces.
      </p>

      <h2>7. Processing of candidates’ personal data</h2>
      <p>
        Comstream and the Customer are jointly considered to be Processors of personal data
        according to GDPR. Both parties commit on adhering to GDPR and other relevant legislation as
        for the handling of personal data of candidates.
      </p>
      <p>
        A Candidate’s personal data will be processed after acceptance of Jobshark’s Integrity
        Policy.
      </p>

      <h2>8. Security</h2>
      <p>
        The Customer is responsible to ensure that user name and password will not be disclosed to
        unauthorized persons. Comstream is responsible to enforce adequate security measures to
        protect your stored information.
      </p>

      <h2>9. Limitation of Liability</h2>
      <p>
        Comstream is not responsible for any indirect damages of any kind and the liability is in
        all cases limited to the amount that the Customer has paid for the service.
      </p>

      <h2>10. Applicable Laws</h2>
      <p>
        This Contract shall be governed by the laws of Sweden and any dispute shall be settled by a
        general Swedish court of law.
      </p>

      <h2>11. Changes to user conditions</h2>
      <p>
        If there are significant changes to this policy, Comstream will notify you via email or
        through a message on the site.
      </p>
    </div>
  </section>
</template>
<script>
import titleMixin from '../../mixins/titleMixin';
export default {
  mixins: [titleMixin],
  title: 'User Conditions for Employers | Jobshark',
};
</script>
<style lang="scss" scoped>
.container {
  padding: 80px 0;
}
</style>
